module.exports = __webpack_public_path__ + "static/media/ufo_bird2.3c20de07.svg";